import { Component } from '@angular/core';
import { GLOBAL_TOAST_KEY } from '@core/constants';

@Component({
    selector: 'mnc-documents-shared-toast',
    template: '<p-toast position="bottom-left" styleClass="custom-toast" [key]="key"></p-toast>',
    standalone: false
})
export class SharedToastComponent {
  key = GLOBAL_TOAST_KEY
}
